<template>
  <div class="app">
    <nav class="navbar">
      <div class="logo">
        <router-link to="/" class="logo-link">
          <img src="@/assets/images/logo.svg" alt="Logo" class="logo-icon" />
        </router-link>
      </div>
      <div class="nav-content">
        <div class="nav-links">
          <router-link to="/">{{ $t('nav.home') }}</router-link>
          <router-link to="/products">{{ $t('nav.products') }}</router-link>
          <router-link to="/network">{{ $t('nav.network') }}</router-link>
          <router-link to="/about">{{ $t('nav.about') }}</router-link>
          <router-link to="/news">{{ $t('nav.news') }}</router-link>
          <div class="language-switch">
            <select v-model="currentLanguage" @change="changeLanguage">
              <option value="zh">中文</option>
              <option value="en">English</option>
            </select>
          </div>
        </div>
      </div>
    </nav>
    <router-view></router-view>
    <footer class="footer">
      <div class="footer-nav">
        <div class="footer-section" style="text-align: left;">
          <h4>{{ $t('footer.links.title') }}</h4>
          <ul>
            <li><router-link to="/">{{ $t('nav.home') }}</router-link></li>
            <li><router-link to="/products">{{ $t('nav.products') }}</router-link></li>
            <li><router-link to="/network">{{ $t('nav.network') }}</router-link></li>
            <li><router-link to="/about">{{ $t('nav.about') }}</router-link></li>
          </ul>
        </div>
        <div class="footer-section" style="text-align: left;">
          <h4>{{ $t('footer.contact.title') }}</h4>
          <p>{{ $t('about.contact.address.content') }}</p>
          <p>{{ $t('about.contact.phone.content') }}</p>
          <p>{{ $t('about.contact.email.content') }}</p>
        </div>
        <div class="footer-section" style="text-align: left;">
          <h4>{{ $t('footer.social.title') }}</h4>
          <ul>
            <li><a href="#" target="_blank">{{ $t('home.socialMedia.wechat') }}</a></li>
            <li><a href="#" target="_blank">{{ $t('home.socialMedia.weibo') }}</a></li>
          </ul>
        </div>
      </div>
      <p>{{ $t('footer.copyright') }}</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentLanguage: 'zh'
    }
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.currentLanguage
      localStorage.setItem('language', this.currentLanguage) // 保存语言设置
    }
  },
  created() {
    // 从本地存储中恢复语言设置
    const savedLanguage = localStorage.getItem('language')
    if (savedLanguage) {
      this.currentLanguage = savedLanguage
      this.$i18n.locale = savedLanguage
    }
  },
  mounted() {
    document.title = this.$t('pageTitle'); // 修改网站标题
  }
}
</script>

<style>
:root {
  --primary-color: #1890ff;
  --primary-light: #40a9ff;
  --primary-dark: #096dd9;
  --text-primary: #262626;
  --text-secondary: #595959;
  --background-light: #ffffff;
  --background-gray: #f5f5f5;
  --border-color: #e8e8e8;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--background-light);
}

.navbar {
  display: flex;
  justify-content: space-between;
  min-height: 6rem;
  align-items: center;
  padding: 0rem  2rem;
  background-color: var(--background-light);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.nav-content {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo-link:hover {
  transform: scale(1.02);
}

.logo-icon {
  display: flex;
  width: 180px;
  height: 110px;
  object-fit: cover;
  object-position: 0 -10px;
  justify-content: center;
  overflow: hidden;
  animation: pulse 2s infinite;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-links a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
  padding: 0.5rem 0;
  position: relative;
}

.nav-links a:hover {
  color: var(--primary-color);
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
}

.nav-links a:hover::after {
  width: 100%;
}

.language-switch select {
  display: flex;
  align-items: end;
  padding: 0.5rem 0;
  border: none;
  height: 2.3rem;;
  background-color: transparent;
  color: var(--text-primary);
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.language-switch select:hover {
  color: var(--primary-color);
}

.language-switch {
  position: relative;
}

/* 移除箭头 */
.language-switch::after {
  display: none;
}

.language-switch select::-ms-expand {
  display: none;
}

.footer {
  margin-top: auto;
  padding: 2rem;
  background-color: var(--background-gray);
  text-align: center;
  color: var(--text-secondary);
  border-top: 1px solid var(--border-color);
}

.footer-nav {
  display: flex;
  justify-content: space-around;
  margin-bottom: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section {
  text-align: left;
}

.footer-section h4 {
  font-size: 1.2rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 0.5rem;
}

.footer-section ul li a {
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: var(--primary-color);
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .nav-links {
    flex-direction: column;
    gap: 1rem;
  }

  .footer-nav {
    flex-direction: column;
    align-items: center;
  }
}
</style> 